// extracted by mini-css-extract-plugin
export default {"card":"NewOnMarketItem_card__9if3M","logo":"NewOnMarketItem_logo__Grjzt"};